/*
 * Auto "load more" (infinite scroll) for collection pages.
 * - Auto-loads the next page when the sentinel nears the viewport.
 * - De-duplicates by product URL so the same product is never appended twice.
 * - Removes itself once the last page is reached.
 * - Filter-safe: derives the page from the current URL (keeps filter/sort params)
 *   and re-initialises when Dawn replaces the grid after filtering.
 */
(function () {
  function pageOfHref(href) {
    try {
      return parseInt(new URL(href, window.location.origin).searchParams.get('page') || '1', 10);
    } catch (e) {
      return 1;
    }
  }

  function lastPageIn(root, current) {
    var max = current;
    root.querySelectorAll('.pagination-wrapper a[href]').forEach(function (a) {
      var p = pageOfHref(a.getAttribute('href'));
      if (p > max) max = p;
    });
    return max;
  }

  function itemKey(item) {
    var a = item.querySelector('a[href]');
    return a ? a.getAttribute('href').split('?')[0] : item.innerHTML.slice(0, 60);
  }

  function urlForPage(p) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', String(p));
    return u.pathname + u.search;
  }

  function init() {
    var grid = document.getElementById('product-grid');
    var pag = document.querySelector('.pagination-wrapper');
    if (!grid || !pag) return;
    // Wire each grid exactly once — guards against re-init loops.
    if (grid.dataset.twLoadMore === 'on') return;
    grid.dataset.twLoadMore = 'on';

    var current = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    var lastPage = lastPageIn(document, current);
    if (lastPage <= current) return; // single page — nothing to do

    pag.style.display = 'none';

    var seen = new Set();
    grid.querySelectorAll('.grid__item').forEach(function (it) { seen.add(itemKey(it)); });

    var wrap = document.createElement('div');
    wrap.className = 'tw-load-more__wrap';
    var status = document.createElement('span');
    status.className = 'tw-load-more__count';
    status.textContent = seen.size + ' Artikel';
    wrap.appendChild(status);
    pag.parentNode.insertBefore(wrap, pag);

    var nextPage = current + 1;
    var busy = false;
    var done = false;
    var io = null;

    function finish() {
      done = true;
      if (io) io.disconnect();
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }

    function loadNext() {
      if (busy || done) return;
      busy = true;
      status.textContent = 'Lädt …';
      fetch(urlForPage(nextPage))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var added = 0;
          doc.querySelectorAll('#product-grid .grid__item').forEach(function (it) {
            var k = itemKey(it);
            if (!seen.has(k)) {
              seen.add(k);
              grid.appendChild(document.importNode(it, true));
              added += 1;
            }
          });
          lastPage = Math.max(lastPage, lastPageIn(doc, current));
          nextPage += 1;
          busy = false;
          if (added === 0 || nextPage > lastPage) {
            finish();
          } else {
            status.textContent = seen.size + ' Artikel';
            // If the sentinel is still in view, keep loading.
            if (io) { io.unobserve(wrap); io.observe(wrap); }
          }
        })
        .catch(function () {
          busy = false;
          status.textContent = seen.size + ' Artikel';
        });
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '700px 0px' });
      io.observe(wrap);
    } else {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--secondary tw-load-more';
      btn.textContent = 'Mehr laden';
      btn.addEventListener('click', loadNext);
      wrap.insertBefore(btn, status);
    }
  }

  function boot() {
    init();
    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var g = document.getElementById('product-grid');
        if (g && g.dataset.twLoadMore !== 'on') init(); // re-wire only a fresh grid
      }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
